module.exports = __webpack_public_path__ + "static/media/testimonials2.7da88106.jpg";